/**
 * Sequence-diagram row-handle ids — the single source of truth.
 *
 * Same keystone idea as ERD `columnHandleId`: the lifeline node RENDERS a handle
 * per row/side using `sequenceRowHandleId`, and the layout REFERENCES the same
 * ids on the message edges — so a referenced handle can never be missing on the
 * node (React Flow silently drops edges whose handle id is absent).
 */

export function sequenceRowHandleId(row: number, side: 'left' | 'right'): string {
  return `seq-${row}-${side}`
}

/** Every row-handle id a lifeline of `rowCount` rows renders (both sides). */
export function sequenceRowHandleIds(rowCount: number): string[] {
  const out: string[] = []
  for (let r = 0; r < rowCount; r++) {
    out.push(sequenceRowHandleId(r, 'left'), sequenceRowHandleId(r, 'right'))
  }
  return out
}
